import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { HiOutlineDocumentDownload, HiOutlineExternalLink } from "react-icons/hi";
import ResumeContent from "./ResumeContent";
import pdf from "./pdf/newResume.pdf";
import { achievements, education, experiences, profile } from "../../data/portfolio";
import "./Resume.css";

const Resume = () => {
  return (
    <Container fluid className="resume-section section-shell">
      <Container>
        <Row className="align-items-end g-4 resume-intro">
          <Col lg={8}>
            <div className="section-kicker">Resume</div>
            <h1 className="section-title">Two years of shipping, measured in outcomes.</h1>
          </Col>
          <Col lg={4}>
            <div className="cta-row resume-actions">
              <Button variant="primary" href={pdf} target="_blank">
                <HiOutlineDocumentDownload /> Download CV
              </Button>
              <Button variant="outline-light" href={profile.linkedin} target="_blank">
                <HiOutlineExternalLink /> LinkedIn
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="resume g-5">
          <Col lg={7} className="resume-left">
            <h2 className="resume-section-title">Experience</h2>
            {experiences.map((experience) => (
              <ResumeContent
                key={`${experience.company}-${experience.period}`}
                title={`${experience.role} · ${experience.company}`}
                date={`${experience.period} · ${experience.meta} · ${experience.stack}`}
                content={experience.bullets}
              />
            ))}
          </Col>
          <Col lg={5} className="resume-right">
            <h2 className="resume-section-title">Education</h2>
            <ResumeContent
              title={`${education.degree} · ${education.school}`}
              date={education.period}
              content={[`CGPA ${education.cgpa}`]}
            />

            <h2 className="resume-section-title">Achievements</h2>
            <ResumeContent title="" content={achievements} />

            <div className="resume-contact glass-panel scroll-reveal">
              <h3>Contact</h3>
              <a href={`mailto:${profile.email}`}>{profile.email}</a>
              <a href={profile.github} target="_blank" rel="noreferrer">
                github.com/sagnik2001
              </a>
              <a href={profile.linkedin} target="_blank" rel="noreferrer">
                linkedin.com/in/sagnik-pal-4437b2209
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Resume;
